import styles from './ComingSoon.module.css';

const ComingSoon = ({ 
  compact = false, 
  persianText = 'به زودی',
  englishText = 'Coming Soon' 
}) => {
  const containerClasses = [
    styles.container,
    compact && styles.compact
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      <div className={styles.card}>
        <div className={styles.glowEffect}></div>
        <div className={styles.persianText}>{persianText}</div>
        <div className={styles.subtitle}>{englishText}</div>
        <div className={styles.decorativeDots}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
